import React, { useContext, useEffect, useRef, useState } from "react";
import { Col } from "react-bootstrap";
import { FormProvider, useForm } from "react-hook-form";
import { DisassemblyOfGoodsDetail } from "./DisassemblyOfGoodsDetail";
import AssemblyDisassemblyOfGoodsDetailSkeleton from "./AssemblyDisassemblyOfGoodsDetailSkeleton";
import { AssemblyDisassemblyOfGoodsDto } from "../dtos/AssemblyDisassemblyOfGoodsDto";
import { AssemblyDisassemblyOfGoodsModel } from "../models/AssemblyDisassemblyOfGoodsModel";
import { useAppSelector } from "../../../../../../redux/hooks/hooks";
import { selectSubmitCounter } from "../../../../../../redux/slices/submitCounterSlice";
import useRunError from "../../../../../Shared/useRunError";
import { NewDocumentModalViewContext } from "../../../../../Shared/NewDocumentModalView";
import handleFormSubmit, { DocumentSaveActionType } from "../../../../../../helpers/DocumentHelper";
import { NFTabs } from "../../../../../Shared/NewForms/NFTabs";
import { NFTab } from "../../../../../Shared/NewForms/NFTab";
import { NFLookupInput } from "../../../../../Shared/NewForms/NFLookupInput";
import { NFTabContainer } from "../../../../../Shared/NewForms/NFTabContainer";
import { AssemblyDisassemblyOfGoodsDetailMain } from "./AssemblyDisassemblyOfGoodsDetailMain";
import { AssemblyDisassemblyOfGOodsDetailProducts } from "./AssemblyDisassemblyOfGOodsDetailProducts";
import { AssemblyDisassemblyOfGoodsDetailAdditional } from "./AssemblyDisassemblyOfGoodsDetailAdditional";
import { AppEntities } from "../../../../../../config/entities";
import { importFromExcel } from "../../../../../../helpers/SaveObjectToExcel";
import { saveObjectToExcel } from "../../../../../../helpers/SaveObjectToExcel";
import { AssemblyDisassemblyOfGoodsDetailFOoter } from "./AssemblyDisassemblyOfGoodsDetailFOoter";
import DocumentDetailViewToolbar from "../../../../../Shared/DetailViews/DocumentDetailViewToolbar";
import DetailViewPostButton from "../../../../../Shared/DetailViews/DetailViewPostButton";
import DetailViewSaveButton from "../../../../../Shared/DetailViews/DetailViewSaveButton";
import DetailViewCancelButton from "../../../../../Shared/DetailViewCancelButton";
import DetailViewToolbarMoreActions from "../../../../../Shared/DetailViews/DetailViewToolbarMoreActions";
import { AssemblyDisassemblyOperationTypeEnum } from "../dtos/AssemblyDisassemblyOperationTypeEnum";
import { useFetchAssemblyDisassemblyOfGoods } from "../hooks/fetchDocument";

interface IProps {
  id?:string;
}

export const AssemblyDisassemblyOfGoodsDetail = ({ id}: IProps) => {
  const [tabIndex, setTabIndex] = useState(0);

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors, isValid },
    reset,
    formState,
    getValues,
    watch,
    control,
    trigger,
    ...methods
  } = useForm<AssemblyDisassemblyOfGoodsModel>();
  const [showComponent1, setShowComponent1] = useState(false);
  const [showComponent2, setShowComponent2] = useState(false);
  const [fileName, setFileName] = useState("Assembly Disassembly Of Goods");

  const AssemblyDisassemblyOpertationType = [
    { id: AssemblyDisassemblyOperationTypeEnum.Assembly, name: "Assembly" },
    {
      id: AssemblyDisassemblyOperationTypeEnum.Disassembly,
      name: "Disassembly"
    }
  ];
  const watchOperationType = watch("operationType");

  const counter = useAppSelector(selectSubmitCounter);
  const runError = useRunError(isValid, errors, counter);

  useEffect(() => {
    if (errors.companyId?.type === "required" || errors.warehouseId?.type === "required") {
      runError();
    }
  }, [errors, runError]);

  useEffect(() => {
    switch (watchOperationType) {
      case AssemblyDisassemblyOperationTypeEnum.Assembly:
        setShowComponent1(true);
        setShowComponent2(false);
        break;
      case AssemblyDisassemblyOperationTypeEnum.Disassembly:
        setShowComponent1(false);
        setShowComponent2(true);
        break;
      default:
        setShowComponent1(false);
        setShowComponent2(false);
    }
  }, [watchOperationType]);

  const modalViewContext = useContext(NewDocumentModalViewContext);
  const { isDocumentLoading, documentModel, postDocument, cancelDocument, updateDocument } = useFetchAssemblyDisassemblyOfGoods({ documentId: id });

  useEffect(() => {
    if (documentModel) {
      reset(documentModel);
    }
  }, [documentModel]);

  useEffect(() => {
    if (formState.isDirty) {
      console.log("formState.isDirty", formState.isDirty);
      updateDocument(getValues());
    }
  }, [formState.isDirty]);

  const handlePost = async () => {
    await postDocument();
  };

  const handleCancel = async () => {
    await cancelDocument();
  };

  // const exportToExcel = () => {
  //   const data = {
  //     ...model
  //   };
  //   const documentInfo = {
  //     title: AppEntities.StockTakings.title,
  //     number: model.documentNumber,
  //     date: model.documentDate
  //   };
  //   saveObjectToExcel(data, documentInfo);
  // };

  // const handleUploadFile = (file: File) => {
  //   importFromExcel(file, (data: any) => {
  //     reset(data);
  //   });
  // };
  return (
    <FormProvider
      getValues={getValues}
      setValue={setValue}
      register={register}
      control={control}
      trigger={trigger}
      reset={reset}
      watch={watch}
      handleSubmit={handleSubmit}
      formState={formState}
      {...methods}
    >
      <NFTabs
        onTabChange={(newIndex) => {
          setTabIndex(newIndex);
        }}
      >
        <NFTab title={"Main"} />
        <NFTab title={"Products"} />
        <NFTab title={"Additional"} />
      </NFTabs>

      <div className={"modal-container-height"}>
        {/* <DocumentDetailViewToolbar>
          <DetailViewPostButton onPost={handleSubmit((data) => handleFormSubmitLocal("post", data))} />
          <DetailViewSaveButton onSave={handleSubmit((data) => handleFormSubmitLocal("save", data))} />
          <DetailViewCancelButton onCancel={cancelHandler} />
          <DetailViewToolbarMoreActions handleUploadFile={handleUploadFile} exportToExcel={exportToExcel} fileName={fileName} setFileName={setFileName} />
        </DocumentDetailViewToolbar> */}

           <DocumentDetailViewToolbar>
            <DetailViewPostButton onPost={handlePost} />
            <DetailViewCancelButton onCancel={handleCancel} />
          </DocumentDetailViewToolbar>

        <div className="panel panel-primary tabs-style-2">
          <Col sm={6}>
            <NFLookupInput title={"Operation type"} fieldName={"operationType"} items={AssemblyDisassemblyOpertationType} />
          </Col>

          <div className=" tab-menu-heading">
            <div className="tabs-menu1">
              {/* <!-- Tabs --> */}
              {showComponent1 && (
                <NFTabContainer index={0} currentIndex={tabIndex}>
                  <AssemblyDisassemblyOfGoodsDetailMain />
                </NFTabContainer>
              )}

              {showComponent1 && (
                <NFTabContainer index={1} currentIndex={tabIndex}>
                  <AssemblyDisassemblyOfGOodsDetailProducts />
                </NFTabContainer>
              )}

              {showComponent1 && (
                <NFTabContainer index={2} currentIndex={tabIndex}>
                  <AssemblyDisassemblyOfGoodsDetailAdditional />
                </NFTabContainer>
              )}
              {showComponent2 && (
                <DisassemblyOfGoodsDetail
                  // model={model}
                  id={id}
                  tabIndex={tabIndex}
                  setTabIndex={setTabIndex}
                  // handleUploadFile={handleUploadFile}
                  // exportToExcel={exportToExcel}
                  fileName={fileName}
                  setFileName={setFileName}
                />
              )}
            </div>
          </div>
        </div>
      </div>
      <AssemblyDisassemblyOfGoodsDetailFOoter />
    </FormProvider>
  );
};
